import { useRef } from 'react';

export const useDragHandler = (onDrag) => {
  const dragData = useRef({ active: false, lastX: 0, lastY: 0 });

  const handleMouseDown = (e) => {
    dragData.current.active = true;
    dragData.current.lastX = e.clientX;
    dragData.current.lastY = e.clientY;
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!dragData.current.active) return;
    const dx = e.clientX - dragData.current.lastX;
    const dy = e.clientY - dragData.current.lastY;
    dragData.current.lastX = e.clientX;
    dragData.current.lastY = e.clientY;
    onDrag(dx, dy);
  };

  const handleMouseUp = () => {
    dragData.current.active = false;
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
  };

  return { handleMouseDown, handleMouseMove, handleMouseUp };
};